import { useEffect } from 'react';

export function useEffectOnce(callback) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(callback, []);
}

export function useEffectControlled(callback, deps) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(callback, deps);
}
